module.exports = __webpack_public_path__ + "img/13.1925b4ec.jpg";